<div class="rounded-xl px-4 py-3 border shadow-inner backdrop-blur-md transition-all duration-300"
     [ngClass]="{
       'bg-gradient-to-br from-[#0c0c0c] via-[#131313] to-[#1b1b1b] border-purple-900/50': isDarkMode(),
       'bg-gradient-to-br from-white via-neutral-50 to-gray-100 border-gray-300/50': !isDarkMode()
     }">

  <!-- ✅ Header -->
  <div class="text-xs font-mono mb-2 tracking-wide"
       [ngClass]="{
         'text-green-400': isDarkMode(),
         'text-gray-700': !isDarkMode()
       }">
    [&#64; {{ tokenIn }} → {{ tokenOut }}] Real-time swap analysis
  </div>
  <!-- 🕐 Loading indicator -->
  <div *ngIf="isLoading"
       class="text-xs italic font-mono mb-2"
       [ngClass]="{
       'text-purple-400': isDarkMode(),
       'text-gray-500': !isDarkMode()
     }">
    Loading trends...
  </div>

  <!-- ✅ Trend Lines -->
  <div *ngIf="!isLoading">
    <div *ngFor="let entry of trendEntries" class="flex items-center text-sm font-mono mb-1">

      <!-- Terminal-style arrow -->
      <span [ngClass]="{ 'text-green-700': isDarkMode(), 'text-gray-500': !isDarkMode() }" class="mr-2">↳</span>

      <!-- Timeframe -->
      <span [ngClass]="{ 'text-gray-400': isDarkMode(), 'text-gray-500': !isDarkMode() }" class="w-[48px]">[{{ entry.key }}]</span>

      <!-- Value with ↗ icon if positive -->
      <span [ngClass]="{'text-green-400 underline decoration-green-400 decoration-2 underline-offset-4 cursor-pointer hover:text-green-300 transition-colors duration-150' : (entry.value>
        0) && isDarkMode(),'text-red-400': (entry.value <= 0) && isDarkMode(),

        'text-green-600 underline decoration-green-600 decoration-2 underline-offset-4 cursor-pointer hover:text-green-500 transition-colors duration-150': (entry.value > 0) && !isDarkMode(),
        'text-red-500': (entry.value <= 0) && !isDarkMode()
        }"
        (click)="entry.value > 0 ? handleTrendClick(entry.value) : null">
        <span class="inline-block" *ngIf="entry.value > 0">↗</span>
        {{ entry.value }}%
      </span>

      <!-- 🏷 Badge unique -->
      <span *ngIf="trendEntries.length === 1"
            [ngClass]="{
            'bg-purple-900/20 text-purple-300': isDarkMode(),
            'bg-purple-100 text-purple-600': !isDarkMode()
          }"
            class="ml-2 text-xs px-2 py-0.5 rounded-full">
        unique
      </span>
    </div>
    </div>
  </div>
